import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';

type Props = {};

export default forwardRef(function PasswordInput(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, ref) {
  const [isPassword, setIsPassword] = React.useState<boolean>(true);
  return (
    <>
      <input {...props} ref={ref as any} type={isPassword ? 'password' : 'text'} />
      <div style={{ position: 'absolute', top: 30, right: 20, zIndex: 2, cursor: 'pointer' }} onClick={() => setIsPassword(x => !x)}>
        <FontAwesomeIcon color="#cccccc" width={16} icon={isPassword ? faEyeSlash : faEye} />
      </div>
    </>
  );
});
